export default "__VITE_ASSET__Cwx1Gtxk__"